import { Component } from '@angular/core';

@Component({
  selector: 'app-advt-invoice-register-office-vbriefly',
  templateUrl: './advt-invoice-register-office-vbriefly.component.html',
  styleUrl: './advt-invoice-register-office-vbriefly.component.scss'
})
export class AdvtInvoiceRegisterOfficeVBrieflyComponent {

  
}
